import React, { useCallback, useMemo } from 'react';
import { Box, RoundDoneIcon, Text, useResponsive } from '@common-fe/common-fe';

import AppButton from '@/components/controls/AppButton';

import useCardReplaceModalStore from '../../store/useCardReplaceModal.store';

interface Props {
  onCancel?: (value: boolean) => void;
  setDoneMode?: () => void;
  onSnackbar?: (props: unknown) => void;
  refreshCardList?: () => void;
  cardholderName?: string;
}

export const CardReplaceAcceptMessage: React.FC<Props> = ({
  onCancel,
  setDoneMode,
  onSnackbar,
  refreshCardList,
  cardholderName,
}) => {
  const { isMobile } = useResponsive();
  const { handleReset } = useCardReplaceModalStore();
  const messageText = useMemo(
    () => `${cardholderName}'s card has been requested and will be mailed in 3-5 days`,
    [cardholderName]
  );

  const onResetModalData = useCallback(() => {
    if (setDoneMode && onSnackbar) {
      setDoneMode();
      onSnackbar({ text: messageText, closeIcon: true });
      handleReset();
    }
  }, [handleReset, messageText, onSnackbar, setDoneMode]);

  const handleCancel = useCallback(() => {
    if (onCancel && refreshCardList) {
      refreshCardList();
      onCancel(false);
      onResetModalData();
    }
  }, [onCancel, onResetModalData, refreshCardList]);

  return (
    <Box
      align="center"
      pad={
        isMobile
          ? { top: 'spacing12', bottom: 'spacing24', horizontal: 'spacing4' }
          : { top: 'spacing12', bottom: 'spacing32' }
      }
      data-testid="CardReplaceAcceptMessage"
    >
      <Box margin={{ bottom: isMobile ? 'spacing24' : 'spacing32' }}>
        <RoundDoneIcon />
      </Box>
      <Text
        margin={{ bottom: 'spacing8' }}
        size={isMobile ? 'xxlarge' : '2xl'}
        style={{ fontWeight: 700, textAlign: 'center' }}
      >
        We’ve Received Your Card Replacement Request!
      </Text>
      <Text
        margin={{ bottom: isMobile ? 'spacing24' : 'spacing32' }}
        size={isMobile ? 'medium' : 'large'}
        textAlign="center"
      >
        Card will be mailed in 3-5 days
      </Text>
      <AppButton type="button" onClick={handleCancel} width={isMobile ? 'full' : 'control'}>
        Got it!
      </AppButton>
    </Box>
  );
};
